var _rect, _path, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaixa12 = function SvgFaixa12(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    fill: "#FFBA08",
    stroke: "url(#paint0_linear_152_1090)",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78942 7.27273H8.05504L5.89453 8.64062V10.277L7.89311 9.02415H7.94425V16H9.78942V7.27273ZM11.8636 16H18.0852V14.4915H14.4205V14.4318L15.6946 13.1832C17.4886 11.5469 17.9702 10.7287 17.9702 9.7358C17.9702 8.22301 16.7344 7.15341 14.8636 7.15341C13.0312 7.15341 11.7741 8.24858 11.7784 9.96165H13.5298C13.5256 9.12642 14.054 8.61506 14.8509 8.61506C15.6179 8.61506 16.1889 9.09233 16.1889 9.85938C16.1889 10.554 15.7628 11.0312 14.9702 11.794L11.8636 14.6705V16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_1090",
    x1: 1.875,
    y1: -6.39469e-7,
    x2: 24,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCB51",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaixa12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faixa_12.6846aac2.svg";
export { ForwardRef as ReactComponent };